import reducer from './reducer';
import List from './Schedule';

const Schedule = {
  List,
  reducer
};

export default Schedule;
